import React, {useState, useEffect} from "react";  
import {Formik} from "formik";  
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import webRootContext from "../components/webrootcontext/WebRootContext";

import CheckBoxesObj from "../framework/CheckBoxesObj";
import {EXP_OBJECT} from '../components/ExpectaionObj.js';

//import { UserProfile } from "../components/UserProfileProvider"; 
	
 
 function ExpectationsForm()  {
    
	const [saveSuccess, setSaveSuccess] = useState();
	const [saveFailed, setSaveFailed] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [thisAppId, setThisAppId] = useState();
	const [applicationCompleted,  setApplicationCompleted] = useState(false);
	
	const getApplicantIdUrl =  webRootContext + "/rest/dashboard/getApplicantId";

	const [checkBoxAnswer, setCheckBoxAnswer] = useState();
	const [finalObj, setFinalObj] = useState(EXP_OBJECT);
	const [agreementCompleted, setAgreementCompleted] = useState(false);
	const [applicationAccepted, setApplicationAccepted] = useState();
	const getDashboardStatusUrl =  webRootContext + "/rest/dashboard/getStatus";


  	let expBoxData = [
    	{ id:1, value: 1, label: "I understand and agree to abide by the expectations outlined above.", name: "Yes", selected: false }
	];	

	const saveSuccessContent = 
	<div>
		<div className="padding-bottom-30">Thank you for submitting the expectations agreement.</div>
		<div><Button text={"RETURN TO DASHBOARD"} styleName={"button button--primary"} id={"returnForm"} onClick={(e) => {returnToDashboard();}} /></div>
	</div>;
	
	const saveFailedContent = 
	<div>
		<div className="padding-bottom-30">Sorry, an error has occured.</div>
		<div className="padding-bottom-30">Please review your form below. If you problems continue, please email the Observership Program at <a href="mailto:observership.program@childrens.harvard.edu">observership.program@childrens.harvard.edu</a>.</div>
	</div>;
	
	const alreadySubmittedContent = 
	<div>
		<div className="padding-bottom-30">This task has already been submitted.</div>
			<Button
		       text={"RETURN TO DASHBOARD"}
		       styleName={"button button--primary"}
		       id={"button_submit"}
		       type="submit"
			   onClick={(e) => {returnToDashboard();}}
		       />
	</div>;

   const notApplicableContent = 
	<div>
		<div className="padding-bottom-30">Please return to the dashboard to view the status of your application and how to proceed.</div>
			<Button
		       text={"RETURN TO DASHBOARD"}
		       styleName={"button button--primary"}
		       id={"button_submit2"}
		       type="submit"
			   onClick={(e) => {returnToDashboard();}}
		       />
	</div>;

useEffect(() => {	
		fetch(getApplicantIdUrl, {
				    method: 'GET', 
			   		headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
							},
					mode: "cors"})
				.then((response) => {
					return response.json();					
				})
				.then((data) => {	
					setThisAppId(data.applicantId);
					setApplicationCompleted(data.isApplicationCompleted);
					getDashboardStatusData(data.applicantId);
				},(error) => {
					console.log("dashboard error: ",  error);
				});	
				
	//Check to see if the user has already completed form 
		function getDashboardStatusData(applicantId){
	       const url =  getDashboardStatusUrl + "?applicantId="+applicantId ;
		   let formCompleted = false;	
		   
           fetch(url, {
			    method: 'GET', 
		   		headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
						},
				mode: "cors"})
				.then((response) => {
					return response.json();					
				})
				.then((data) => {	
					console.log("dashboard applicant id:", data.applicantId);
				
				setApplicationAccepted(data.applicantId > 0 && data.isAccepted);
				for(const item in data.requirementList)
				{
					if(data.requirementList[item].label === "Expectations Agreement" && data.requirementList[item].status === "completed")
				     {
						 formCompleted = true;
						 break;
					 }
				}
		   
		  	setAgreementCompleted(formCompleted);	 
				},(error) => {
					console.log("dashboard error: ",  error);
				});	  
   };

}, [getApplicantIdUrl, getDashboardStatusUrl, thisAppId]); 


  function returnToDashboard() {
      window.location.href = webRootContext + "/ApplicantDashboard";
  }                   
	
function populateFinalObj() {
	setFinalObj({...finalObj, applicantId: thisAppId});
  };

	
 function SubmitForm() {
        let url = webRootContext + "/rest/expectAgree/saveExpectAgree";
         fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: JSON.stringify(finalObj),
	    	mode:"cors"})
 		    .then((response) => {
                 if (response.ok) {
					// Clear the form and display the success message.
					setSaveSuccess(true);
		    			setSaveFailed(false);                     

                 } else {

					setSaveSuccess(false);
		    		setSaveFailed(true);  
                    //return null
                 }						  
					return response.json();
		    })
		    .catch((err) => {
          		console.log("error", err); 
	  		});        
    }

	return (
        <div>
        
            <div id="completed" className={ !applicationCompleted && agreementCompleted ? 'show_div' : 'hide_div'}>
	         	<div id="alreadySubmittedDiv" className="div_1_col">
					<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={alreadySubmittedContent} />
				</div>
	         </div>
	         
	         <div id="noAcceptedApplication" className={ !applicationCompleted && (applicationAccepted || applicationAccepted === undefined) ? 'hide_div':'show_div' }>
	         	<div id="notApplicableDiv" className="div_1_col">
					<Ribbon label="RETURN TO DASHBOARD" status={"error"} subheader={""} content={notApplicableContent} />
				</div>
	         </div>
        
	        <div id="formikForm" className={ applicationCompleted || agreementCompleted || !applicationAccepted ? 'hide_div' : 'show_div'}>
	       		  <Formik
					initialValues={{
						expBox: "0"
					 }}
				 	validate={values => {
						 const errors = {};		 
	                
	                
			        if (values.expBox !== 1) { 
			             errors.expBox = 'Expectations agreement is required';
			         } 
	
					if( Object.keys(errors).length > 0) {
						setFormikError(true);
						}
						
						else {
							setFormikError(false);
				        }	
		          
				         return errors;
			       }}
				 
				 onSubmit={(values, { setSubmitting }) => {
							
			          setTimeout(() => {
				 	
					  	SubmitForm();
		          		setSubmitting(false); 	          	    	          		
			          }, 100);
			        }}			 
				 >
				 
				   { ({
			          values ,
			          errors ,
			          touched,
			          handleChange,
			          handleBlur,
			          handleSubmit,
			          isSubmitting,
			          isValid,
			          dirty,
			          validateForm
			        }) => (
					
			<form onSubmit={handleSubmit} noValidate>
	
				<div id="formikErrors" className={(formikError && formSubmitted ? 'show_div' : 'hide_div')}>
					<div id="formikFailDiv" className="div_1_col">
						<Ribbon label="REVIEW ISSUES BELOW" status={"error"} subheader={""} content={""} />
					</div>
				</div>
	
				<div id="saveSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
					<div id="saveSuccessDiv" className="div_1_col">
						<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={saveSuccessContent} />
					</div>
				</div>
								 		 
				<div id="saveFailed" className={(saveFailed === 'true' ? 'show_div' : 'hide_div')}>
					<div id="saveFailedDiv" className="div_1_col">
						<Ribbon label="ERROR" status={"error"} subheader={""} content={saveFailedContent} />
					</div>
				</div>
	
				<div id="headerDiv" className={saveSuccess ? 'hide_div' : 'show_div div_1_col'}>
					<div className="breadcrumbLink"><a href="##" onClick={(e) => {returnToDashboard();}}>Dashboard</a></div>         
					<div className="page_title">Observership Expectations Agreement</div>
				</div>
	
				<div id="formInputs" className={(saveSuccess ? 'hide_div' : 'show_div' )} >
	
					<div id="divPageInfo" className="div_1_col padding-bottom-30">
						<div class="normal_txt">Please read the following and accept the agreement at the bottom</div>
					</div>
	
					<div id="textInfo" className="div_3_col">
					<hr className="hr--dot-boston-pink" />
					<div class="page_description">
						Expectations for Observers
					</div>
					<div class="normal_txt padding-bottom-20">
					The general purpose of an Observership is to watch and listen only with no patient contact and no research activity. Observerships are undertaken solely for the purposes of gaining knowledge to be utilized in the observer’s practice at their home institution. There will be no compensation, no fringe or benefits, no educational credit, and no employment relationship with BCH in connection with the Observership.
					<br/><br/>
					The following guidelines apply to the participation in the Observership Program:
					<ul>
						<li>Observerships are generally available for currently practicing, licensed clinicians to watch and listen with no hands-on patient contact or research activity. Observerships may include programs for residents, fellows, and other clinicians (e.g. psychologists, social workers, nutritionists) as determined by the host department.</li>
						<li>Observers must be currently practicing with a home institution affiliation or be enrolled in a formal training program such as a residency or fellowship.</li>
						<li>The Observership Program generally is not intended to include: individuals who are not enrolled or have completed medical school, USMLE applicants, or individuals intending to complete research projects.</li>
						<li>Observers will not be permitted any direct, physical patient contact and may not perform any patient services which includes, but is not limited to, performing the following functions: taking medical history, performing physical examination, diagnosing and treating patient’s condition, prescribing and administering drugs, writing notes or orders in patient’s chart, performing and assisting in a procedure, or billing for services rendered. Observers may be present during case discussions, but may not directly participate in case advisement and under no circumstances, should discuss any patient seen or encountered (this includes verbal, written, and electronic communication).</li>
						<li>Observers must be clearly identified to all patients and staff, and permission must be obtained from each patient (or proxy) for observer to be present during any encounter / procedure. Should a patient request an observer to leave at any point during an encounter, the observer must leave at once. An observer may not behave or speak in any manner that would lead a patient to believe that s/he is a practicing clinician on staff at BCH.</li>
						<li>Observerships are generally limited to four weeks, but can be a maximum of twelve weeks with appropriate department approval.</li>
						<li>Observers will not be permitted to engage in research activities involving a laboratory research, research protocol, research project/paper, or any other research work.</li>
						<li>Observers are responsible for their personal transportation, accommodations, meals, medical insurance, required immunizations and any other personal expenses incurred while at BCH.</li>
						<li>Observers must comply with the minimum insurance guidelines provided by the Observership Program office. BCH will not be responsible for any coverage not included by the insurance policy.</li>
						<li>Observers will complete prior to the commencement of the Observership a health status assessment which complies with all applicable BCH policies, rules and regulations, and immunization requirements. Observers will refrain from patient care observation at any time if the observer has an infectious disease or condition that could be transmitted to patients.</li>
						<li>Observers are not practicing physicians or providers at BCH and therefore malpractice insurance is not required.</li>
						<li>Observers must wear an ID badge provided by Human Resources upon completion of the institutional orientation and prior to entering the hosting department. The badge will display the title of “Observer” and must be returned to the Observership Program office at the end of the observer appointment.</li>
						<li>Observers will not be considered employees or staff members of BCH and will not be entitled to salary, benefits, reimbursement of expenses or other compensation; nor will this Observer appointment apply towards elective credit or transcripts for completion of educational programs (i.e., clinical schools, residencies or fellowships).</li>
						<li>BCH will not provide any letters of reference, recommendation or commendation on behalf of Observers; upon successful completion of an Observership, a certificate of attendance will be issued by the Observership Program office.</li>
						<li>Observers must comply with all BCH standards, rules and regulations, as well as all applicable federal, state and local laws pertaining to government health care programs.</li>
						<li>Disclosure of confidential patient or other BCH information is prohibited by BCH policy and during the term of the Observership, the Observer may have access to confidential patient and other BCH information such as: BCH business information, machines, technologies, and active research and development activities in the Boston Children's Hospital including but not limited to the Simulator Program (Immersive Design Systems), SIMEngineering, SIMInventor Space, SIMPeds SIM3D Print locations; research information, including information describing or relating to inventions or discoveries; information concerning outside companies with which BCH does business, including data BCH is contractually obligated to keep confidential.</li>
						<li>In the event the Observer is permitted to take photographs or is given materials, the Observer will only use the foregoing for educational purposes and will not copy or redistribute to any third party without prior written permission from BCH.</li>
						<li>The Observer, faculty host or BCH may terminate this appointment at any time and for any reason prior to the scheduled conclusion of the observer appointment by providing written or oral notice to the other party. The Observer acknowledges that there is no grievance, appeal or other due process procedures available to challenge the termination of an Observer appointment.</li>
					</ul>
					<br/> 
					Observers May:
					<ul>
						<li>Attend BCH conferences, lectures, seminars and committee meetings with prior approval from clinical host division and mentor. Observe both inpatient and outpatient clinical activities with prior approval from host division and mentor.</li>
						<li>Have a basic network logon and “read only” access to Epic (if approved by the host division).</li>
					</ul>
					<br/> 
					Observers May Not:
					<ul>
						<li>Administer treatment or render services to patients.</li>
						<li>Be involved in obtaining patient consent for any encounter or procedure (clinical or research).</li>
						<li>Participate in patient care management, including writing orders or notes in patient records and / or giving verbal orders related to patient care.</li>
						<li>Be listed in the BCH telephone directory.</li>
						<li>Access any clinical or research electronic information systems applications under any other users.</li>
						<li>Access BCH information after the term of the Observership has ended. This includes any computer/online access granted as part of the observership such as confidential patient information and BCH closed meetings or other sessions (whether digitally or via Zoom).</li>
						<li>Publish any works that imply a formal affiliation with BCH.</li>
						<li>Obligate BCH financially or suggest or imply that s/he is acting with the authority of BCH.</li>
					</ul>
					<br/> 
					Visitor Dress Code
					<ul>
						<li>Business or business casual attire (dress pants, dress shirt and tie, close-toed shoes). Observers are expected to present themselves in a neat, polished and professional manner.</li>
						<li>If a clinical department requires that an observer wears a lab coat, the observer is required to wear the lab coat issued by their home institution. BCH will not provide lab coats.</li>
						<li>The following items should NOT be worn in the hospital:
							<ul>
								<li>Jeans, shorts, mini-skirts, sweatpants, sneakers or flip-flops</li>
								<li>Hats or caps, unless part of a uniform</li>
								<li>Clothing with suggestive themes or content inappropriate for children</li>
								<li>Clothing with political content or with slogans</li>
								<li>Tank tops, halter-tops, tube tops, sleeveless t-shirts and other very casual summer clothing</li>
								<li>Distracting or revealing clothing</li>
							</ul>
						</li>
					</ul>
					</div>
					</div>
			 		
				  <div id="div1" className="div_3_col">
					<hr className="hr--dot-boston-pink" />
					
					<CheckBoxesObj
					id={"expBox"}
					label="Expectations agreement"
					name="expBox"
					data={expBoxData}
					selectedItem={checkBoxAnswer}
					isRequired={true}
					layoutVertical={false}
					value={(selectedItems) => {}}
					onChange={(selectedItems) => {setCheckBoxAnswer(selectedItems);
					touched.expBox = true;
					if (selectedItems.length === 1)
						{
							setFinalObj({...finalObj, isReviewSigned: 1})
							values.expBox = 1;
						}
					else
						{
							setFinalObj({...finalObj, isReviewSigned: 0})
							values.expBox = 2;
						}
						validateForm();
					 }}
				
	        		hasError={touched.expBox && errors.expBox}
			        errorMessage={errors.expBox}
					onBlur={(x) => {touched.expBox = true; }}					
					onFocus={(x) => {touched.expBox = true; }}
					/>
	
			             </div>	
	
	
			             <hr className="hr--light" />
			             <div className="div_1_col horizontal_div">
			             
			             <Button
			                text={"I ACCEPT AND CERTIFY"}
			                styleName={"button button--primary"}
			                id={"button_submit"}
			                type="submit"
							onClick={(e) =>{populateFinalObj();setFormSubmitted(true); window.scrollTo({top: 0, left: 0, behavior: 'auto'});}}
			              />
			            </div>
			 		  
			 		  </div>     				 	
			        </form>
					 
					 
					 )}
			 </Formik>
		</div>
       </div>
    )
    };

export default ExpectationsForm;
	